const CancelablePromise = require('../CancelablePromise');

module.exports = (url) => {
  return new CancelablePromise((resolve) => {
    const image = new Image();
    image.onload = () => {
      resolve([
        image.naturalWidth || image.width || 0,
        image.naturalHeight || image.height || 0,
      ]);
    };
    image.src = url;
  });
};
